import React, { useEffect } from 'react';
import Filters from './Filters';
import SpecialtyPromotion from './SpecialtyPromotion';

const Sidebar = ({ categories, contentTypes, journals, journalIds, updateTypes, updateCategories, updateJournals, submitUpdate, categoryIds, id, categoryIdPreSelected }) => {

  useEffect(() => {
  }, []);

  const publisherHealthAd = () => {
    if (categoryIdPreSelected) {
      return (
        <div className="row">
          <div className="small-12 columns">
            <div className='cureus-ad-wrapper'>
              <div className='cureus-ad publisher-health-ad square'>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="small-3 columns show-for-large-up">
      <Filters
        categories={categories}
        categoryIds={categoryIds}
        contentTypes={contentTypes}
        journals={journals}
        journalIds={journalIds}
        updateTypes={updateTypes}
        updateCategories={updateCategories}
        updateJournals={updateJournals}
        submitUpdate={submitUpdate}
        id={id}
        categoryIdPreSelected={categoryIdPreSelected}
      />
      {categoryIdPreSelected &&
        <SpecialtyPromotion categoryIdPreSelected={categoryIdPreSelected} />
      }
      {publisherHealthAd()}
    </div>
  );
};

export default Sidebar;